import React from 'react';
import { ExternalLink } from 'lucide-react';

export function LoadingScreen({ brand }) {
  const bg = brand?.background_color || '#111114';
  const pc = brand?.primary_color || '#D44E20';
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: bg }}>
      <div className="w-8 h-8 border-2 border-t-transparent rounded-full animate-spin" style={{ borderColor: pc, borderTopColor: 'transparent' }} />
    </div>
  );
}

export function InvalidLink({ brand }) {
  const bg = brand?.background_color || '#111114';
  const tc = brand?.text_color || '#FFFFFF';
  const ts = brand?.text_secondary_color || '#888888';
  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: bg }}>
      <div className="text-center animate-fade-in-up">
        <div className="w-16 h-16 bg-[#FF5555]/15 rounded-2xl flex items-center justify-center mx-auto mb-4">
          <ExternalLink size={28} className="text-[#FF5555]" />
        </div>
        <h1 className="text-xl font-bold mb-2" style={{ color: tc }}>Link non valido</h1>
        <p className="text-sm" style={{ color: ts }}>Questo link non esiste o e' scaduto.</p>
      </div>
    </div>
  );
}
